define("shared/utils/number-helpers/floor-to-significant-digits", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  /**
   * @class floorToSignificantDigits
   * @extends Utils
   */

  /**
   *
   * @method floorToSignificantDigits
   * @param {Number} num Number
   * @param {Number} significantDigits Number of significant digits to round to
   *
   * @return {Number} Rounded down number to the significant digits provided
   */
  const floorToSignificantDigits = (num, significantDigits) => {
    const roundingFactor = 10 ** (num.toString().length - significantDigits);
    return Math.floor(Number(num / roundingFactor.toPrecision(significantDigits + 1))) * roundingFactor;
  };

  var _default = floorToSignificantDigits;
  _exports.default = _default;
});